/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { DialogActions, Box, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import { WorkOrderYesNoType } from '../../../../../API';
import Button, { ButtonType } from '../../../../../Shared/Components/Common/Buttons/Button';
import { IAdjustProofRequirementsPopupProps } from '../AllSchedules.Model';

import { Icons } from '../../../../../Shared/Constants/Icons';

import { buttonStyles } from '../../../../Jobs/Components/AddEditOneTimeJob/AddEditOneTimeJob.Style';
import { CloseIconStyle } from '../../../../../Shared/Components/Common/SuccessMessagePopup/SuccessMessagePopup.Style';
import { ModifyScheduleText } from '../AllJobs.Style';
import { DialogWrapper } from '../../CreateBid.Style';

const AdjustProofRequirementsPopup = ({
  open,
  onClose,
  onSubmit,
  selectedOption,
  onOptionChange,
  isUpdating,
  title,
  options,
  cancelButtonText,
  confirmButtonText,
}: IAdjustProofRequirementsPopupProps) => {
  const { radioButton, radioButtonText } = buttonStyles;

  return (
    <DialogWrapper open={open} onClose={onClose}>
      <CloseIconStyle onClick={onClose}>
        <img src={Icons.InfoWindowCloseIcon} alt="Close" />
      </CloseIconStyle>

      <ModifyScheduleText sx={{ marginBottom: 0 }}>{title}</ModifyScheduleText>

      <Box sx={{ gap: '2rem', padding: '1rem' }}>
        <Box sx={{ marginTop: '1rem' }}>
          <RadioGroup value={selectedOption} onChange={(e) => onOptionChange(e.target.value as WorkOrderYesNoType)}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio sx={{ ...radioButton }} />}
                label={option.label}
                sx={{ ...radioButtonText, marginBottom: '1rem' }}
              />
            ))}
          </RadioGroup>
        </Box>
      </Box>

      <DialogActions>
        <Button type={ButtonType.Secondary} onClick={onClose} label={cancelButtonText} disabled={isUpdating} />
        <Button
          type={ButtonType.Primary}
          onClick={onSubmit}
          disabled={!selectedOption || isUpdating}
          label={confirmButtonText}
          isLoading={isUpdating}
        />
      </DialogActions>
    </DialogWrapper>
  );
};

export default AdjustProofRequirementsPopup;
